import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function state() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            active: true
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`state/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`state/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('state/create', data);
    }

    function update(data) {
        return axiosInstance.patch('state/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`state/delete`, {
            data: {
                id: id
            }
        });
    }
}
